import { render, staticRenderFns } from "./CustomerSupplierSelect.vue?vue&type=template&id=f723ea54"
import script from "./CustomerSupplierSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSupplierSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports